import { useEffect, useState } from "react";

// Seconds since `since`, ticking once a second while it is set.
export const useElapsed = (since: Date | undefined) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!since) return;
    const handle = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(handle);
  }, [since]);
  return since ? Math.max(0, Math.floor((now - since.getTime()) / 1000)) : null;
};
